module.exports = __webpack_public_path__ + "static/media/YM84_5.96008de6.jpg";